import Alpine from 'alpinejs';
import { Breakpoints } from "../breakpoints.js";
import { slideDown, slideToggle, slideUp, slideToggleDefaults } from './snippets/slide-toggle-container.js';
import { ReverseTrackingHover } from './modules/_ReverseTrackingHover.js';
import { register } from 'swiper/element/bundle';
import { Modal } from './modules/_Modal.js';
import AudioPlayer from './modules/_AudioPlayer.js';
import { ShyHeader } from './modules/_ShyHeader.js';
import LaunchKlaviyForm from './modules/_LaunchKlaviyForm.js';
register();

window.setSectionTabindex = (el, to = "-1") => {
  [...(el instanceof NodeList
    ? el
    : el.querySelectorAll('a, input, button'))
    ].forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};

window.slideToggle = (el, opts = {}) => {
  slideToggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  slideUp(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  slideDown(el, { ...slideToggleDefaults, ...opts });
};
window.createFocusTrap = (el, opts = {}) => createFocusTrap(el, opts);

window.Breakpoints = Breakpoints;

Alpine.data('ReverseTrackingHover', ReverseTrackingHover);
Alpine.data('AudioPlayer', AudioPlayer);
Alpine.data('ShyHeader', ShyHeader);
Alpine.bind('LaunchKlaviyForm', LaunchKlaviyForm);
Alpine.store('modal', Modal);
Alpine.store('klaviyoFormsOpenend', []);

window.Alpine = Alpine;
